// @generated by protoc-gen-es v2.12.0 with parameter "target=ts"
// @generated from file dag/dag.proto (package lvdr.v2.dag, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { Timestamp } from "@bufbuild/protobuf/wkt";
import { file_google_protobuf_timestamp } from "@bufbuild/protobuf/wkt";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file dag/dag.proto.
 */
export const file_dag_dag: GenFile = /*@__PURE__*/
  fileDesc("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", [file_google_protobuf_timestamp]);

/**
 * @generated from message lvdr.v2.dag.DAGNode
 */
export type DAGNode = Message<"lvdr.v2.dag.DAGNode"> & {
  /**
   * @generated from field: string node_id = 1;
   */
  nodeId: string;

  /**
   * @generated from field: string research_id = 2;
   */
  researchId: string;

  /**
   * "agent", "collector", "quality_gate", etc.
   *
   * @generated from field: string type = 3;
   */
  type: string;

  /**
   * @generated from field: string agent_name = 4;
   */
  agentName: string;

  /**
   * @generated from field: string template_name = 5;
   */
  templateName: string;

  /**
   * "created", "queued", "running", etc.
   *
   * @generated from field: string status = 6;
   */
  status: string;

  /**
   * @generated from field: string output_path = 7;
   */
  outputPath: string;

  /**
   * "required", "optional", "nice_to_have"
   *
   * @generated from field: string priority = 8;
   */
  priority: string;

  /**
   * @generated from field: repeated string channels = 9;
   */
  channels: string[];

  /**
   * @generated from field: bool skip_in_batch = 10;
   */
  skipInBatch: boolean;

  /**
   * @generated from field: int32 output_version = 11;
   */
  outputVersion: number;

  /**
   * @generated from field: google.protobuf.Timestamp created_at = 12;
   */
  createdAt?: Timestamp | undefined;

  /**
   * @generated from field: google.protobuf.Timestamp started_at = 13;
   */
  startedAt?: Timestamp | undefined;

  /**
   * @generated from field: google.protobuf.Timestamp completed_at = 14;
   */
  completedAt?: Timestamp | undefined;

  /**
   * @generated from field: string error_message = 15;
   */
  errorMessage: string;

  /**
   * @generated from field: string error_class = 16;
   */
  errorClass: string;

  /**
   * FE-36: a completed node that produced nothing usable (placeholder section,
   * zero-chunk prepare, or sub-floor retrieval). Derived server-side via
   * domain.DeriveNodeDegraded — NOT a terminal status; the node's real `status`
   * stays "completed". The FE renders it warning-tinted instead of green.
   *
   * @generated from field: bool degraded = 17;
   */
  degraded: boolean;

  /**
   * one-sentence human reason when degraded
   *
   * @generated from field: string degraded_reason = 18;
   */
  degradedReason: string;

  /**
   * --- Rich detail (tags 19+) ---
   *
   * These live on lvdr.v2.node.Node and were invisible in the DAG view, which is
   * why the DAG inspect panel showed no tokens, goal or quality while the sibling
   * graph panel did. Joined server-side from the durable node store.
   *
   * IMPORTANT — this message also rides the LIVE path:
   * ResearchProgressView.nodes is `repeated DAGNode`, so every field added here
   * is broadcast on every metrics tick. The heavy fields (input, output,
   * metadata) are therefore left ZERO on the live mirror and populated only on
   * the cold GetDAGNode fetch; `output` is unbounded node content and
   * replicating it into the broadcast would bloat the WS stream for data nobody
   * is looking at. Consumers must treat an absent `output` on a live node as
   * "not fetched yet", which is DISTINCT from "empty".
   *
   * @generated from field: string goal = 19;
   */
  goal: string;

  /**
   * @generated from field: int32 tokens_in = 20;
   */
  tokensIn: number;

  /**
   * @generated from field: int32 tokens_out = 21;
   */
  tokensOut: number;

  /**
   * @generated from field: double quality_score = 22;
   */
  qualityScore: number;

  /**
   * @generated from field: int32 citation_count = 23;
   */
  citationCount: number;

  /**
   * @generated from field: int32 depth = 24;
   */
  depth: number;

  /**
   * @generated from field: string parent_id = 25;
   */
  parentId: string;

  /**
   * Whitelisted node metadata (see node.FilterWireMetadata). Small and
   * allow-listed, unlike the bodies above. Populated on the GetDAGNode fetch;
   * deliberately NOT stamped onto the live progress mirror.
   *
   * @generated from field: map<string, string> metadata = 28;
   */
  metadata: { [key: string]: string };
};

/**
 * Describes the message lvdr.v2.dag.DAGNode.
 * Use `create(DAGNodeSchema)` to create a new message.
 */
export const DAGNodeSchema: GenMessage<DAGNode> = /*@__PURE__*/
  messageDesc(file_dag_dag, 0);

/**
 * @generated from message lvdr.v2.dag.DAGEdge
 */
export type DAGEdge = Message<"lvdr.v2.dag.DAGEdge"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string from_node = 2;
   */
  fromNode: string;

  /**
   * @generated from field: string from_path = 3;
   */
  fromPath: string;

  /**
   * @generated from field: string to_node = 4;
   */
  toNode: string;

  /**
   * @generated from field: bool active = 5;
   */
  active: boolean;
};

/**
 * Describes the message lvdr.v2.dag.DAGEdge.
 * Use `create(DAGEdgeSchema)` to create a new message.
 */
export const DAGEdgeSchema: GenMessage<DAGEdge> = /*@__PURE__*/
  messageDesc(file_dag_dag, 1);

/**
 * @generated from message lvdr.v2.dag.TemplateGroup
 */
export type TemplateGroup = Message<"lvdr.v2.dag.TemplateGroup"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string name = 2;
   */
  name: string;

  /**
   * @generated from field: repeated string node_ids = 3;
   */
  nodeIds: string[];
};

/**
 * Describes the message lvdr.v2.dag.TemplateGroup.
 * Use `create(TemplateGroupSchema)` to create a new message.
 */
export const TemplateGroupSchema: GenMessage<TemplateGroup> = /*@__PURE__*/
  messageDesc(file_dag_dag, 2);

/**
 * @generated from message lvdr.v2.dag.DAGGraphEvent
 */
export type DAGGraphEvent = Message<"lvdr.v2.dag.DAGGraphEvent"> & {
  /**
   * @generated from field: string research_id = 1;
   */
  researchId: string;

  /**
   * "node_status", "nodes_added", etc.
   *
   * @generated from field: string event_type = 2;
   */
  eventType: string;

  /**
   * @generated from field: string node_id = 3;
   */
  nodeId: string;

  /**
   * @generated from field: google.protobuf.Timestamp timestamp = 4;
   */
  timestamp?: Timestamp | undefined;

  /**
   * @generated from oneof lvdr.v2.dag.DAGGraphEvent.payload
   */
  payload: {
    /**
     * @generated from field: lvdr.v2.dag.NodeStatusPayload node_status = 10;
     */
    value: NodeStatusPayload;
    case: "nodeStatus";
  } | {
    /**
     * @generated from field: lvdr.v2.dag.NodesAddedPayload nodes_added = 11;
     */
    value: NodesAddedPayload;
    case: "nodesAdded";
  } | {
    /**
     * @generated from field: lvdr.v2.dag.TemplateInstantiatedPayload template_instantiated = 12;
     */
    value: TemplateInstantiatedPayload;
    case: "templateInstantiated";
  } | {
    /**
     * @generated from field: lvdr.v2.dag.NodesInvalidatedPayload nodes_invalidated = 13;
     */
    value: NodesInvalidatedPayload;
    case: "nodesInvalidated";
  } | {
    /**
     * @generated from field: lvdr.v2.dag.GraphStatePayload graph_state = 14;
     */
    value: GraphStatePayload;
    case: "graphState";
  } | {
    /**
     * @generated from field: lvdr.v2.dag.ChannelOutputPayload channel_output = 15;
     */
    value: ChannelOutputPayload;
    case: "channelOutput";
  } | {
    /**
     * @generated from field: lvdr.v2.dag.HeartbeatPayload heartbeat = 16;
     */
    value: HeartbeatPayload;
    case: "heartbeat";
  } | { case: undefined; value?: undefined };
};

/**
 * Describes the message lvdr.v2.dag.DAGGraphEvent.
 * Use `create(DAGGraphEventSchema)` to create a new message.
 */
export const DAGGraphEventSchema: GenMessage<DAGGraphEvent> = /*@__PURE__*/
  messageDesc(file_dag_dag, 3);

/**
 * @generated from message lvdr.v2.dag.NodeStatusPayload
 */
export type NodeStatusPayload = Message<"lvdr.v2.dag.NodeStatusPayload"> & {
  /**
   * @generated from field: string status = 1;
   */
  status: string;

  /**
   * @generated from field: string output_path = 2;
   */
  outputPath: string;

  /**
   * @generated from field: string agent_name = 3;
   */
  agentName: string;

  /**
   * @generated from field: string node_type = 4;
   */
  nodeType: string;
};

/**
 * Describes the message lvdr.v2.dag.NodeStatusPayload.
 * Use `create(NodeStatusPayloadSchema)` to create a new message.
 */
export const NodeStatusPayloadSchema: GenMessage<NodeStatusPayload> = /*@__PURE__*/
  messageDesc(file_dag_dag, 4);

/**
 * @generated from message lvdr.v2.dag.NodesAddedPayload
 */
export type NodesAddedPayload = Message<"lvdr.v2.dag.NodesAddedPayload"> & {
  /**
   * @generated from field: repeated lvdr.v2.dag.DAGNode nodes = 1;
   */
  nodes: DAGNode[];

  /**
   * @generated from field: repeated lvdr.v2.dag.DAGEdge edges = 2;
   */
  edges: DAGEdge[];

  /**
   * @generated from field: string template_name = 3;
   */
  templateName: string;
};

/**
 * Describes the message lvdr.v2.dag.NodesAddedPayload.
 * Use `create(NodesAddedPayloadSchema)` to create a new message.
 */
export const NodesAddedPayloadSchema: GenMessage<NodesAddedPayload> = /*@__PURE__*/
  messageDesc(file_dag_dag, 5);

/**
 * @generated from message lvdr.v2.dag.TemplateInstantiatedPayload
 */
export type TemplateInstantiatedPayload = Message<"lvdr.v2.dag.TemplateInstantiatedPayload"> & {
  /**
   * @generated from field: string instance_id = 1;
   */
  instanceId: string;

  /**
   * @generated from field: string template_name = 2;
   */
  templateName: string;

  /**
   * @generated from field: repeated string node_ids = 3;
   */
  nodeIds: string[];
};

/**
 * Describes the message lvdr.v2.dag.TemplateInstantiatedPayload.
 * Use `create(TemplateInstantiatedPayloadSchema)` to create a new message.
 */
export const TemplateInstantiatedPayloadSchema: GenMessage<TemplateInstantiatedPayload> = /*@__PURE__*/
  messageDesc(file_dag_dag, 6);

/**
 * @generated from message lvdr.v2.dag.NodesInvalidatedPayload
 */
export type NodesInvalidatedPayload = Message<"lvdr.v2.dag.NodesInvalidatedPayload"> & {
  /**
   * @generated from field: repeated string node_ids = 1;
   */
  nodeIds: string[];

  /**
   * @generated from field: string strategy = 2;
   */
  strategy: string;
};

/**
 * Describes the message lvdr.v2.dag.NodesInvalidatedPayload.
 * Use `create(NodesInvalidatedPayloadSchema)` to create a new message.
 */
export const NodesInvalidatedPayloadSchema: GenMessage<NodesInvalidatedPayload> = /*@__PURE__*/
  messageDesc(file_dag_dag, 7);

/**
 * @generated from message lvdr.v2.dag.GraphStatePayload
 */
export type GraphStatePayload = Message<"lvdr.v2.dag.GraphStatePayload"> & {
  /**
   * @generated from field: string state = 1;
   */
  state: string;

  /**
   * @generated from field: string reason = 2;
   */
  reason: string;
};

/**
 * Describes the message lvdr.v2.dag.GraphStatePayload.
 * Use `create(GraphStatePayloadSchema)` to create a new message.
 */
export const GraphStatePayloadSchema: GenMessage<GraphStatePayload> = /*@__PURE__*/
  messageDesc(file_dag_dag, 8);

/**
 * @generated from message lvdr.v2.dag.ChannelOutputPayload
 */
export type ChannelOutputPayload = Message<"lvdr.v2.dag.ChannelOutputPayload"> & {
  /**
   * @generated from field: string channel = 1;
   */
  channel: string;

  /**
   * @generated from field: bytes data = 2;
   */
  data: Uint8Array;

  /**
   * @generated from field: bool append = 3;
   */
  append: boolean;
};

/**
 * Describes the message lvdr.v2.dag.ChannelOutputPayload.
 * Use `create(ChannelOutputPayloadSchema)` to create a new message.
 */
export const ChannelOutputPayloadSchema: GenMessage<ChannelOutputPayload> = /*@__PURE__*/
  messageDesc(file_dag_dag, 9);

/**
 * @generated from message lvdr.v2.dag.HeartbeatPayload
 */
export type HeartbeatPayload = Message<"lvdr.v2.dag.HeartbeatPayload"> & {
  /**
   * @generated from field: int32 tokens_in = 1;
   */
  tokensIn: number;

  /**
   * @generated from field: int32 tokens_out = 2;
   */
  tokensOut: number;

  /**
   * @generated from field: int64 elapsed_ms = 3;
   */
  elapsedMs: bigint;

  /**
   * @generated from field: string phase = 4;
   */
  phase: string;

  /**
   * @generated from field: string model = 5;
   */
  model: string;

  /**
   * @generated from field: bool stream_active = 6;
   */
  streamActive: boolean;
};

/**
 * Describes the message lvdr.v2.dag.HeartbeatPayload.
 * Use `create(HeartbeatPayloadSchema)` to create a new message.
 */
export const HeartbeatPayloadSchema: GenMessage<HeartbeatPayload> = /*@__PURE__*/
  messageDesc(file_dag_dag, 10);

/**
 * @generated from message lvdr.v2.dag.SubscribeDAGRequest
 */
export type SubscribeDAGRequest = Message<"lvdr.v2.dag.SubscribeDAGRequest"> & {
  /**
   * @generated from field: string research_id = 1;
   */
  researchId: string;
};

/**
 * Describes the message lvdr.v2.dag.SubscribeDAGRequest.
 * Use `create(SubscribeDAGRequestSchema)` to create a new message.
 */
export const SubscribeDAGRequestSchema: GenMessage<SubscribeDAGRequest> = /*@__PURE__*/
  messageDesc(file_dag_dag, 11);

/**
 * @generated from message lvdr.v2.dag.UnsubscribeDAGRequest
 */
export type UnsubscribeDAGRequest = Message<"lvdr.v2.dag.UnsubscribeDAGRequest"> & {
  /**
   * @generated from field: string research_id = 1;
   */
  researchId: string;
};

/**
 * Describes the message lvdr.v2.dag.UnsubscribeDAGRequest.
 * Use `create(UnsubscribeDAGRequestSchema)` to create a new message.
 */
export const UnsubscribeDAGRequestSchema: GenMessage<UnsubscribeDAGRequest> = /*@__PURE__*/
  messageDesc(file_dag_dag, 12);

/**
 * @generated from message lvdr.v2.dag.RetryNodeRequest
 */
export type RetryNodeRequest = Message<"lvdr.v2.dag.RetryNodeRequest"> & {
  /**
   * @generated from field: string research_id = 1;
   */
  researchId: string;

  /**
   * @generated from field: string node_id = 2;
   */
  nodeId: string;

  /**
   * @generated from field: bool cascade = 3;
   */
  cascade: boolean;
};

/**
 * Describes the message lvdr.v2.dag.RetryNodeRequest.
 * Use `create(RetryNodeRequestSchema)` to create a new message.
 */
export const RetryNodeRequestSchema: GenMessage<RetryNodeRequest> = /*@__PURE__*/
  messageDesc(file_dag_dag, 13);

/**
 * @generated from message lvdr.v2.dag.InvalidateNodeRequest
 */
export type InvalidateNodeRequest = Message<"lvdr.v2.dag.InvalidateNodeRequest"> & {
  /**
   * @generated from field: string research_id = 1;
   */
  researchId: string;

  /**
   * @generated from field: string node_id = 2;
   */
  nodeId: string;

  /**
   * "only", "cascade", "template"
   *
   * @generated from field: string strategy = 3;
   */
  strategy: string;
};

/**
 * Describes the message lvdr.v2.dag.InvalidateNodeRequest.
 * Use `create(InvalidateNodeRequestSchema)` to create a new message.
 */
export const InvalidateNodeRequestSchema: GenMessage<InvalidateNodeRequest> = /*@__PURE__*/
  messageDesc(file_dag_dag, 14);

/**
 * @generated from message lvdr.v2.dag.IgnoreNodeRequest
 */
export type IgnoreNodeRequest = Message<"lvdr.v2.dag.IgnoreNodeRequest"> & {
  /**
   * @generated from field: string research_id = 1;
   */
  researchId: string;

  /**
   * @generated from field: string node_id = 2;
   */
  nodeId: string;
};

/**
 * Describes the message lvdr.v2.dag.IgnoreNodeRequest.
 * Use `create(IgnoreNodeRequestSchema)` to create a new message.
 */
export const IgnoreNodeRequestSchema: GenMessage<IgnoreNodeRequest> = /*@__PURE__*/
  messageDesc(file_dag_dag, 15);

/**
 * SubmitHITLCriteriaRequest carries a user-edited extract_criteria output
 * after a MinItems validator failure surfaced the gap to the user. The
 * server-side handler injects `payload_json` into the strategy interpreter's
 * blockOverrides for `block_id`, then retries the failed node. On the next
 * dispatch the interpreter consumes the override (skipping the LLM call)
 * and re-validates against MinItems — if the user-supplied output is still
 * under-populated, the node re-fails and the HITL loop can repeat.
 *
 * `payload_json` is a UTF-8 JSON object exactly matching the shape the LLM
 * would have returned (e.g. {"entities":[...],"criteria":[...]}). The
 * handler parses it server-side; malformed JSON returns
 * SubmitHITLCriteriaResponse{success: false, error_message: "..."}.
 *
 * @generated from message lvdr.v2.dag.SubmitHITLCriteriaRequest
 */
export type SubmitHITLCriteriaRequest = Message<"lvdr.v2.dag.SubmitHITLCriteriaRequest"> & {
  /**
   * @generated from field: string research_id = 1;
   */
  researchId: string;

  /**
   * @generated from field: string node_id = 2;
   */
  nodeId: string;

  /**
   * @generated from field: string block_id = 3;
   */
  blockId: string;

  /**
   * @generated from field: string payload_json = 4;
   */
  payloadJson: string;
};

/**
 * Describes the message lvdr.v2.dag.SubmitHITLCriteriaRequest.
 * Use `create(SubmitHITLCriteriaRequestSchema)` to create a new message.
 */
export const SubmitHITLCriteriaRequestSchema: GenMessage<SubmitHITLCriteriaRequest> = /*@__PURE__*/
  messageDesc(file_dag_dag, 16);

/**
 * @generated from message lvdr.v2.dag.SubmitHITLCriteriaResponse
 */
export type SubmitHITLCriteriaResponse = Message<"lvdr.v2.dag.SubmitHITLCriteriaResponse"> & {
  /**
   * @generated from field: bool success = 1;
   */
  success: boolean;

  /**
   * @generated from field: string error_message = 2;
   */
  errorMessage: string;

  /**
   * Echo of SubmitHITLCriteriaRequest.node_id so the FE can correlate the
   * response back to a specific in-flight submit (the user may have multiple
   * HITL candidates open across failed nodes; without the echo there is no
   * way to clear the right pendingNodeActions entry).
   *
   * @generated from field: string node_id = 3;
   */
  nodeId: string;
};

/**
 * Describes the message lvdr.v2.dag.SubmitHITLCriteriaResponse.
 * Use `create(SubmitHITLCriteriaResponseSchema)` to create a new message.
 */
export const SubmitHITLCriteriaResponseSchema: GenMessage<SubmitHITLCriteriaResponse> = /*@__PURE__*/
  messageDesc(file_dag_dag, 17);

/**
 * @generated from message lvdr.v2.dag.PauseGraphRequest
 */
export type PauseGraphRequest = Message<"lvdr.v2.dag.PauseGraphRequest"> & {
  /**
   * @generated from field: string research_id = 1;
   */
  researchId: string;
};

/**
 * Describes the message lvdr.v2.dag.PauseGraphRequest.
 * Use `create(PauseGraphRequestSchema)` to create a new message.
 */
export const PauseGraphRequestSchema: GenMessage<PauseGraphRequest> = /*@__PURE__*/
  messageDesc(file_dag_dag, 18);

/**
 * @generated from message lvdr.v2.dag.ResumeGraphRequest
 */
export type ResumeGraphRequest = Message<"lvdr.v2.dag.ResumeGraphRequest"> & {
  /**
   * @generated from field: string research_id = 1;
   */
  researchId: string;
};

/**
 * Describes the message lvdr.v2.dag.ResumeGraphRequest.
 * Use `create(ResumeGraphRequestSchema)` to create a new message.
 */
export const ResumeGraphRequestSchema: GenMessage<ResumeGraphRequest> = /*@__PURE__*/
  messageDesc(file_dag_dag, 19);

/**
 * @generated from message lvdr.v2.dag.GetDAGNodeRequest
 */
export type GetDAGNodeRequest = Message<"lvdr.v2.dag.GetDAGNodeRequest"> & {
  /**
   * @generated from field: string research_id = 1;
   */
  researchId: string;

  /**
   * @generated from field: string node_id = 2;
   */
  nodeId: string;
};

/**
 * Describes the message lvdr.v2.dag.GetDAGNodeRequest.
 * Use `create(GetDAGNodeRequestSchema)` to create a new message.
 */
export const GetDAGNodeRequestSchema: GenMessage<GetDAGNodeRequest> = /*@__PURE__*/
  messageDesc(file_dag_dag, 20);

/**
 * @generated from message lvdr.v2.dag.GetDAGNodeResponse
 */
export type GetDAGNodeResponse = Message<"lvdr.v2.dag.GetDAGNodeResponse"> & {
  /**
   * @generated from field: lvdr.v2.dag.DAGNode node = 1;
   */
  node?: DAGNode | undefined;

  /**
   * @generated from field: repeated lvdr.v2.dag.ChannelInfo channels = 2;
   */
  channels: ChannelInfo[];

  /**
   * @generated from field: repeated lvdr.v2.dag.DAGEdge incoming_edges = 3;
   */
  incomingEdges: DAGEdge[];

  /**
   * @generated from field: repeated lvdr.v2.dag.DAGEdge outgoing_edges = 4;
   */
  outgoingEdges: DAGEdge[];

  /**
   * @generated from field: map<string, string> metadata = 5;
   */
  metadata: { [key: string]: string };

  /**
   * True when this response's channel + metadata detail is trustworthy.
   *
   * Needed because "an old run whose snapshot predates detailed persistence" and
   * "a node that genuinely produced no channels" are byte-identical on the wire
   * otherwise — proto3 decodes an absent repeated field and an empty one the
   * same way. Without this flag the panel cannot tell "we don't know" from
   * "nothing here", and would render every pre-migration run as though its nodes
   * had produced nothing.
   *
   * Always true on the live path (the coordinator has the real graph). On the
   * cold path it reflects the persisted snapshot's schema version.
   *
   * @generated from field: bool detailed_snapshot = 6;
   */
  detailedSnapshot: boolean;
};

/**
 * Describes the message lvdr.v2.dag.GetDAGNodeResponse.
 * Use `create(GetDAGNodeResponseSchema)` to create a new message.
 */
export const GetDAGNodeResponseSchema: GenMessage<GetDAGNodeResponse> = /*@__PURE__*/
  messageDesc(file_dag_dag, 21);

/**
 * @generated from message lvdr.v2.dag.ChannelInfo
 */
export type ChannelInfo = Message<"lvdr.v2.dag.ChannelInfo"> & {
  /**
   * @generated from field: string name = 1;
   */
  name: string;

  /**
   * @generated from field: string mime_type = 2;
   */
  mimeType: string;

  /**
   * @generated from field: int64 size = 3;
   */
  size: bigint;

  /**
   * "final" or "streaming"
   *
   * @generated from field: string mode = 4;
   */
  mode: string;

  /**
   * @generated from field: repeated int32 versions = 5;
   */
  versions: number[];
};

/**
 * Describes the message lvdr.v2.dag.ChannelInfo.
 * Use `create(ChannelInfoSchema)` to create a new message.
 */
export const ChannelInfoSchema: GenMessage<ChannelInfo> = /*@__PURE__*/
  messageDesc(file_dag_dag, 22);

/**
 * FE-36: lazily fetch a DAG node's readable input/output bodies for the
 * inspection panel. Kept separate from GetDAGGraph/GetDAGNode so the graph
 * payload never carries the (to ~24 KB) node bodies — fetched only when the
 * panel's content tab is opened. Backed by research.Service.GetResearchNodeContent.
 *
 * @generated from message lvdr.v2.dag.GetDAGNodeContentRequest
 */
export type GetDAGNodeContentRequest = Message<"lvdr.v2.dag.GetDAGNodeContentRequest"> & {
  /**
   * @generated from field: string research_id = 1;
   */
  researchId: string;

  /**
   * @generated from field: string node_id = 2;
   */
  nodeId: string;
};

/**
 * Describes the message lvdr.v2.dag.GetDAGNodeContentRequest.
 * Use `create(GetDAGNodeContentRequestSchema)` to create a new message.
 */
export const GetDAGNodeContentRequestSchema: GenMessage<GetDAGNodeContentRequest> = /*@__PURE__*/
  messageDesc(file_dag_dag, 23);

/**
 * @generated from message lvdr.v2.dag.GetDAGNodeContentResponse
 */
export type GetDAGNodeContentResponse = Message<"lvdr.v2.dag.GetDAGNodeContentResponse"> & {
  /**
   * @generated from field: string node_id = 1;
   */
  nodeId: string;

  /**
   * → ResultRenderer agentType
   *
   * @generated from field: string agent_type = 2;
   */
  agentType: string;

  /**
   * @generated from field: string status = 3;
   */
  status: string;

  /**
   * @generated from field: string title = 4;
   */
  title: string;

  /**
   * node body (markdown/JSON), lazily fetched
   *
   * @generated from field: string output = 5;
   */
  output: string;

  /**
   * the prompt/context the node received
   *
   * @generated from field: string input = 6;
   */
  input: string;

  /**
   * @generated from field: bool degraded = 7;
   */
  degraded: boolean;

  /**
   * @generated from field: string degraded_reason = 8;
   */
  degradedReason: string;

  /**
   * false ⇒ node type has no inspectable body (not an error)
   *
   * @generated from field: bool found = 9;
   */
  found: boolean;
};

/**
 * Describes the message lvdr.v2.dag.GetDAGNodeContentResponse.
 * Use `create(GetDAGNodeContentResponseSchema)` to create a new message.
 */
export const GetDAGNodeContentResponseSchema: GenMessage<GetDAGNodeContentResponse> = /*@__PURE__*/
  messageDesc(file_dag_dag, 24);

/**
 * @generated from message lvdr.v2.dag.GetDAGNodeChannelRequest
 */
export type GetDAGNodeChannelRequest = Message<"lvdr.v2.dag.GetDAGNodeChannelRequest"> & {
  /**
   * @generated from field: string research_id = 1;
   */
  researchId: string;

  /**
   * @generated from field: string node_id = 2;
   */
  nodeId: string;

  /**
   * @generated from field: string channel_name = 3;
   */
  channelName: string;

  /**
   * 0 = current
   *
   * @generated from field: int32 version = 4;
   */
  version: number;
};

/**
 * Describes the message lvdr.v2.dag.GetDAGNodeChannelRequest.
 * Use `create(GetDAGNodeChannelRequestSchema)` to create a new message.
 */
export const GetDAGNodeChannelRequestSchema: GenMessage<GetDAGNodeChannelRequest> = /*@__PURE__*/
  messageDesc(file_dag_dag, 25);

/**
 * @generated from message lvdr.v2.dag.GetDAGNodeChannelResponse
 */
export type GetDAGNodeChannelResponse = Message<"lvdr.v2.dag.GetDAGNodeChannelResponse"> & {
  /**
   * @generated from field: string channel_name = 1;
   */
  channelName: string;

  /**
   * @generated from field: string mime_type = 2;
   */
  mimeType: string;

  /**
   * @generated from field: bytes data = 3;
   */
  data: Uint8Array;

  /**
   * @generated from field: int32 version = 4;
   */
  version: number;

  /**
   * found=false is a FRIENDLY empty state, not an error — same contract as
   * GetDAGNodeContentResponse.found. The panel renders `reason` instead of a red
   * error box.
   *
   * The common false case is not a bug: channel BYTES are only ever held by a
   * live coordinator. The persisted graph snapshot stores channel DESCRIPTORS
   * only (see dag.NodeSummary), so once a run finishes and its coordinator is
   * torn down, non-primary channel contents are genuinely gone. Saying so
   * plainly beats an error the user cannot act on.
   *
   * @generated from field: bool found = 5;
   */
  found: boolean;

  /**
   * @generated from field: string reason = 6;
   */
  reason: string;
};

/**
 * Describes the message lvdr.v2.dag.GetDAGNodeChannelResponse.
 * Use `create(GetDAGNodeChannelResponseSchema)` to create a new message.
 */
export const GetDAGNodeChannelResponseSchema: GenMessage<GetDAGNodeChannelResponse> = /*@__PURE__*/
  messageDesc(file_dag_dag, 26);

/**
 * @generated from message lvdr.v2.dag.GetDAGGraphRequest
 */
export type GetDAGGraphRequest = Message<"lvdr.v2.dag.GetDAGGraphRequest"> & {
  /**
   * @generated from field: string research_id = 1;
   */
  researchId: string;
};

/**
 * Describes the message lvdr.v2.dag.GetDAGGraphRequest.
 * Use `create(GetDAGGraphRequestSchema)` to create a new message.
 */
export const GetDAGGraphRequestSchema: GenMessage<GetDAGGraphRequest> = /*@__PURE__*/
  messageDesc(file_dag_dag, 27);

/**
 * @generated from message lvdr.v2.dag.GetDAGGraphResponse
 */
export type GetDAGGraphResponse = Message<"lvdr.v2.dag.GetDAGGraphResponse"> & {
  /**
   * @generated from field: string research_id = 1;
   */
  researchId: string;

  /**
   * @generated from field: string state = 2;
   */
  state: string;

  /**
   * @generated from field: string state_reason = 3;
   */
  stateReason: string;

  /**
   * @generated from field: repeated lvdr.v2.dag.DAGNode nodes = 4;
   */
  nodes: DAGNode[];

  /**
   * @generated from field: repeated lvdr.v2.dag.DAGEdge edges = 5;
   */
  edges: DAGEdge[];

  /**
   * @generated from field: repeated lvdr.v2.dag.TemplateGroup templates = 6;
   */
  templates: TemplateGroup[];
};

/**
 * Describes the message lvdr.v2.dag.GetDAGGraphResponse.
 * Use `create(GetDAGGraphResponseSchema)` to create a new message.
 */
export const GetDAGGraphResponseSchema: GenMessage<GetDAGGraphResponse> = /*@__PURE__*/
  messageDesc(file_dag_dag, 28);

/**
 * @generated from message lvdr.v2.dag.GetCachedPageRequest
 */
export type GetCachedPageRequest = Message<"lvdr.v2.dag.GetCachedPageRequest"> & {
  /**
   * source URL — backend computes cache key internally
   *
   * @generated from field: string url = 1;
   */
  url: string;
};

/**
 * Describes the message lvdr.v2.dag.GetCachedPageRequest.
 * Use `create(GetCachedPageRequestSchema)` to create a new message.
 */
export const GetCachedPageRequestSchema: GenMessage<GetCachedPageRequest> = /*@__PURE__*/
  messageDesc(file_dag_dag, 29);

/**
 * @generated from message lvdr.v2.dag.GetCachedPageResponse
 */
export type GetCachedPageResponse = Message<"lvdr.v2.dag.GetCachedPageResponse"> & {
  /**
   * @generated from field: string cache_key = 1;
   */
  cacheKey: string;

  /**
   * @generated from field: string url = 2;
   */
  url: string;

  /**
   * @generated from field: string title = 3;
   */
  title: string;

  /**
   * @generated from field: string markdown = 4;
   */
  markdown: string;

  /**
   * @generated from field: bool found = 5;
   */
  found: boolean;
};

/**
 * Describes the message lvdr.v2.dag.GetCachedPageResponse.
 * Use `create(GetCachedPageResponseSchema)` to create a new message.
 */
export const GetCachedPageResponseSchema: GenMessage<GetCachedPageResponse> = /*@__PURE__*/
  messageDesc(file_dag_dag, 30);

